import { createGraphQLFetchStrategy } from "./graphql.js";
const FRAGMENT_CATEGORIES_NATIVE_FIELDS = `
  fragment CategoryFields on CategoryInterface {
    title
    url
    id
  }
`;
const FRAGMENT_ENTRIES_NATIVE_FIELDS = `
  fragment EntriesNativeFields on EntryInterface {
    id
    uid
    status
    enabled
    slug
    title
    type: typeHandle
    postDate
    expiryDate
    dateUpdated
    dateCreated
  }
`;
const FRAGMENT_EXPERT_JOBS = `
  fragment Jobs on expertsOrganizationJob_Entry {
    id
    url
    title: expertsOrganizationJobTitle
    roomNumber: expertsOrganizationJobRoomNumber
    campusUnits: categoryCampusUnit {
      title
      ... on campusUnits_Category {
        link: externalLink {
          url
        }
      }
    }
  }
`;
const FRAGMENT_EXPERT_NAME = `
  fragment Name on expertsContent_Entry {
    prefix: expertsNamePrefix
    firstName: expertsNameFirst
    middleName: expertsNameMiddle
    lastName: expertsNameLast
    suffix: expertsNameSuffix
    pronouns: expertsNamePronouns
  }
`;
const FRAGMENT_EXPERT_IMAGERY = `
  fragment Imagery on expertsContent_Entry {
    headshot: expertsImageHeadShot {
      ... on experts_Asset {
        url
      }
    }
  }
`;
const FRAGMENT_EXPERT_BIOGRAPHY = `
  fragment Biography on expertsContent_Entry {
    summary: expertsSummary {
      html
    }
    bio: expertsBiography {
      html
    }
  }
`;
const FRAGMENT_ENTRIES_ORGANIZATIONS = `
  fragment Organizations on expertsOrganization_Entry {
    id
    title
    url
    jobs: expertsOrganizationJob {
      ...Jobs
    }
  }
`;
const FRAGMENT_EXPERT_CONTACT = `
  fragment Contact on expertsContent_Entry {
    email: expertsContactEmail
    linkedin: expertsContactLinkedin
    website: expertsContactWebsite
    twitter: expertsContactTwitter
  }
`;
const FRAGMENT_EXPERT_SKILLS = `
  fragment Skills on expertsContent_Entry {
    languages: expertsLanguages
    mediaTrained: expertsMediaTrained
  }
`;
const FRAGMENT_EXPERT_CONTENT = `
  fragment Content on expertsContent_Entry {
    ...Name
    ...Imagery
    ...Biography
    organizations: expertsOrganization {
      ...Organizations
    }
    ...Contact
    ...Skills
  }
`;
const FRAGMENT_EXPERT_CATEGORIES = `
  fragment Categories on expertsContent_Entry {
    areasOfExpertise: expertsCategoryAreaOfExpertise {
      ...CategoryFields
    }
    tags: expertsCategoryTags {
      ...CategoryFields
    }
  }
`;
const EXPERTS_QUERY = `
  query getExpertsContent($limit: Int, $offset: Int, $ids: [QueryArgument], $relatedTo: [QueryArgument], $isMediaTrained: Boolean, $orderBy: String, $fixedOrder: Boolean) {
    entryCount(
      section: "experts"
      limit: $limit
      offset: $offset
      type: "expertsContent"
      id: $ids
      relatedTo: $relatedTo
      expertsMediaTrained: $isMediaTrained
    )
    entries(
      section: "experts"
      limit: $limit
      offset: $offset
      type: "expertsContent"
      id: $ids
      relatedTo: $relatedTo
      expertsMediaTrained: $isMediaTrained
      orderBy: $orderBy
      fixedOrder: $fixedOrder
    ) {
      ...EntriesNativeFields
      ... on expertsContent_Entry {
        ...Content
        ...Categories
      }
    }
  }
  ${FRAGMENT_ENTRIES_NATIVE_FIELDS}
  ${FRAGMENT_CATEGORIES_NATIVE_FIELDS}
  ${FRAGMENT_EXPERT_CONTENT}
  ${FRAGMENT_EXPERT_CATEGORIES}
  ${FRAGMENT_EXPERT_NAME}
  ${FRAGMENT_EXPERT_IMAGERY}
  ${FRAGMENT_EXPERT_BIOGRAPHY}
  ${FRAGMENT_ENTRIES_ORGANIZATIONS}
  ${FRAGMENT_EXPERT_JOBS}
  ${FRAGMENT_EXPERT_CONTACT}
  ${FRAGMENT_EXPERT_SKILLS}
`;
const expertsFetchStrategy = createGraphQLFetchStrategy({
  endpoint: "https://content-api.umd.edu/graphql",
  queries: {
    entries: EXPERTS_QUERY
  },
  transformResponse: (data) => {
    if (!data || !data.data || !data.data.entries) {
      return null;
    }
    return data.data.entries || null;
  },
  transformCount: (data) => {
    if (!data || !data.data) {
      return 0;
    }
    return data.data.entryCount || 0;
  },
  composeVariables: (baseVariables) => {
    const { categories, entriesToRemove, ids, isMediaTrained, ...rest } = baseVariables;
    const variables = { ...rest };
    if (ids) {
      variables.ids = Array.isArray(ids) ? ids : [ids];
      variables.fixedOrder = true;
    } else {
      variables.orderBy = "expertsNameLast";
    }
    if (categories) {
      variables.relatedTo = categories;
    }
    if (isMediaTrained) {
      variables.isMediaTrained = isMediaTrained;
    }
    return variables;
  }
});
export {
  EXPERTS_QUERY,
  expertsFetchStrategy
};
//# sourceMappingURL=experts.js.map
